import React from "react";
import { useNavigate } from "react-router-dom";
import { AxButton, AxIconWrapper, AxSpinner } from "@dynata/axiom3";
import { ChangePass } from "./widgets/ChangePassword.widget";

import "../../../scss/account.scss";
import { useStateContext } from "state";

export const AccountPage: React.FC = () => {
  const state = useStateContext();
  let navigate = useNavigate();

  let back = (
    <AxButton
      style={{ marginLeft: "18px" }}
      type="link"
      onClick={() => navigate("../dashboard")}
    >
      <AxIconWrapper
        type="regular"
        size="24"
        icon={"fa-arrow-left"}
      />
    </AxButton>
  );

  return !!state.tokens?.user_id ? (
    <main className="account">
      <div className="account-tabs">
        <h1>Your Account</h1>
        <ChangePass userId={state.tokens?.user_id} />
      </div>
    </main>
  ) : (
    <AxSpinner />
  );
};
